import React from 'react';
import {GraphicRadioButton} from './graphic-radio-button';
import {GraphicRadioButtonRow} from './graphic-radio-button-row';
import {useFeatureAppId} from '../utils/use-feature-app-id';
import {generateTestId, TestIdElementType} from '../utils/test';

export enum ChargingPowerValues {
  kW23 = '2.3',
  kW11 = '11',
  kW50 = '50',
  kW150 = '150',
  kW350 = '350',
}

export interface ChargingPowerSelectionProps {
  value: ChargingPowerValues | '';
  chargingPower: number[];
  onChange: (newValue: ChargingPowerValues) => void;
  name: string;
  questionTextId: string;
  availableChargingPower?: number[];
}

export const ChargingPowerSelection: React.FC<ChargingPowerSelectionProps> =
  React.memo(
    ({
      value,
      chargingPower,
      onChange,
      name,
      questionTextId,
      availableChargingPower,
    }: ChargingPowerSelectionProps) => {
      const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.stopPropagation();
        onChange(e.target.value as ChargingPowerValues);
      };

      function getAvailablePowerOptions(
        availableChargingPower: number[]
      ): number[] {
        const powerOptions: number[] = [];
        for (const powerOption of availableChargingPower) {
          powerOptions.push(powerOption);
        }
        return powerOptions;
      }
      let availablePowerOptions: number[] = [];
      if (availableChargingPower) {
        availablePowerOptions = getAvailablePowerOptions(
          availableChargingPower
        );
      }
      const featureAppId = useFeatureAppId();
      return (
        <GraphicRadioButtonRow>
          {chargingPower.map((chargePower) => (
            <GraphicRadioButton
              key={chargePower}
              value={`${chargePower}`}
              content={`${chargePower} kW`}
              selected={+value === chargePower}
              onChange={handleChange}
              name={name}
              questionTextId={questionTextId}
              disabled={!availablePowerOptions.includes(chargePower)}
              testId={generateTestId({
                featureAppId,
                elementName: `charge-power-${chargePower
                  .toString()
                  .replace('.', '-')}`,
                elementType: TestIdElementType.button,
              })}
            />
          ))}
        </GraphicRadioButtonRow>
      );
    }
  );

ChargingPowerSelection.displayName = 'ChargingPowerSelection';
